import React from 'react';
import {Row, Col} from 'react-bootstrap';


interface HeaderProps {
  title?: string
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {

  return (
    <Row className="py-2 dark-header">
      <Col className="">
        <h1 className="mb-0" style={{fontSize: '4rem', fontWeight: 'bold', marginLeft: '7rem'}}>
          <img src="/ama-logo.png" alt="AMA" style={{
            marginBottom: '-1.6rem',
            position: 'absolute',
            top: '1rem',
            left: '1rem',
            width: '5rem'
          }}/> {props.title}
        </h1>
      </Col>
    </Row>
  );
};

export default Header;